import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-admin";

interface BreadcrumbNavProps {
  current: string;
}

export const BreadcrumbNav = ({ current }: BreadcrumbNavProps) => {
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 3 }}>
      <Link to="/styleguide" underline="hover">
        Style Guide
      </Link>
      <Typography color="text.primary">{current}</Typography>
    </Breadcrumbs>
  );
};
